import {safeHtml, safeText} from "../../util/CommonUtils.js";

export default class SubstanceBarItem extends HTMLElement {
	#onEditIconClickCallbacks = [];

	/** @param {{name:string, color:string, [substanceId]:string}} data */
	constructor(data) {
		super();
		this._data = data;
	}

	connectedCallback() {
		const template = document.createElement('template');
		template.innerHTML = this._template();
		this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true))

		this.addEventListener('mouseenter', async () => {
			this.shadowRoot.querySelector('slot[name="structure"]').style.display = 'block';
		})

		this.addEventListener('mouseleave', () => {
			this.shadowRoot.querySelector('slot[name="structure"]').style.display = 'none';
		})
		this.shadowRoot.getElementById("pencil").addEventListener('click', async (evt) => {
			evt.stopPropagation();
			for (const cb of this.#onEditIconClickCallbacks)
				cb(this._data);
		})
	}

	onEditIconClick(callback) {
		this.#onEditIconClickCallbacks.push(callback);
	}

	setData(data) {
		this._data = data;
		let span = this.shadowRoot.querySelector('span');
		span.innerText = data.name;
		span.title = safeText(data.name);
		this.shadowRoot.querySelector('.circle').style.backgroundColor = data.color;
	}

	getData() {
		return this._data;
	}

	displayNormal() {
		this.shadowRoot.querySelector('.title').style.opacity = 1;
		this.removeAttribute('selected')
	}

	displayActive() {
		this.shadowRoot.querySelector('.title').style.opacity = 1;
		this.setAttribute('selected', true)
	}

	displayBackground() {
		this.shadowRoot.querySelector('.title').style.opacity = .5;
		this.removeAttribute('selected')
	}

	_template() {
		return safeHtml`
			  <style>
				  slot[name="structure"] {
                    margin-left : -288px;
                    position    : absolute;
                    display     : none;
                    pointer-events : none;
				  }
			  </style>
              <style> @import "/ui/js/components/substance-bar/substanceItem.css?v=2"; </style>
              <slot name="structure"></slot>
              <div class="title">
                <i id="pencil" class="material-symbols-outlined">edit</i>
                <div class="circle" style="background-color: ${this._data.color}"></div>
                <span title="${this._data.name}">${this._data.name}</span>
              </div>
        `;
	}
}